import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_ROOM_OR_EVENT_NAME = "roomOrEventName";

const tLabel = "Name";
const tLengthMax = "Cannot exceed 255 characters";
const tLengthMin = "Must be at least 2 characters";

export interface RoomOrEventNameValidationOptions {
  minLength?: number;
  maxLength?: number;
}

export type RoomOrEventNameProps = ConstructedTextField & {
  validationOptions?: RoomOrEventNameValidationOptions;
};

export const RoomOrEventName = ({ textFieldProps, validationOptions, ...props }: RoomOrEventNameProps) => {
  const { minLength = 2, maxLength = 255 } = validationOptions ?? {};

  return (
    <TextField
      name={FIELD_NAME_ROOM_OR_EVENT_NAME}
      textFieldProps={{
        inputProps: {
          maxLength,
          minLength,
        },
        label: tLabel,
        ...textFieldProps,
      }}
      validate={(value, _, meta) => {
        if (meta?.dirty && value) {
          if (value.length < minLength) {
            return tLengthMin;
          }

          if (value.length > maxLength) {
            return tLengthMax;
          }
        }

        return "";
      }}
      {...props}
    />
  );
};
